import { array, func, object, oneOf, oneOfType, string } from 'prop-types';

import { Link } from 'react-router-dom';
import React from 'react';
import { Button as WrappedButton } from 'reactstrap';
import clsx from 'clsx';
import styles from './styles.module.scss';

const templates = {
  default: {
    color: 'primary',
    className: clsx(styles['template-primary'], 'primary'),
    outline: false,
  },
  secondary: {
    className: styles['template-secondary'],
    outline: true,
  },
  tertiary: {
    color: 'custom',
    className: styles['template-tertiary'],
  },
  'tertiary-link': {
    color: 'custom',
    className: styles['template-tertiary-link'],
  },
};

const Button = ({
  template: templateKey,
  children,
  className = '',
  // eslint-disable-next-line no-unused-vars
  type = 'button',
  ...rest
}) => {
  const tag = (() => {
    if (rest.href) return 'a';
    if (rest.to) return Link;
    return 'button';
  })();

  const template = {
    ...templates['default'],
    ...(templates[templateKey] || {}),
    tag,
    role: rest.href ? 'link' : 'button',
  };

  if (rest.outline !== undefined)
    Object.assign(template, {
      outline: rest.outline,
    });

  Object.assign(template, {
    className: clsx({
      [template.className]: !!template.className,
      [styles.outline]: template.outline,
      [className]: !!className,
    }),
  });

  return (
    <WrappedButton {...template} {...rest}>
      {children}
    </WrappedButton>
  );
};

Button.propTypes = {
  children: oneOfType([array, object, string]),
  color: oneOf(['link', 'primary', 'secondary', 'custom']),
  className: string,
  dataTestid: string,
  href: string,
  to: string,
  template: string,
  type: oneOf(['button', 'reset', 'submit']),
  onClick: func,
};

export default Button;
